import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { getQueryKeyBase, MUTATION_KEYS, queryClient } from '../queryClient';
import { updateCacheArray, CACHE_ACTIONS } from '../cacheClient';
import { getQueryKey as getQueryKeyConceptDeterminationMethods } from './useConceptDeterminationMethods';
import { getQueryKey as getQueryKeyConceptDeterminationMethodById } from './useConceptDeterminationMethodById';

// Config
import { uiConfig } from '../../../conf/conceptDeterminationMethods';

export const getMutationKey = getQueryKeyBase.bind(null, MUTATION_KEYS.CONCEPT_DETERMINATION_METHOD);

export const useUpdateConceptDeterminationMethod = ({
    crudConfig,
    sessionToken,
    onSuccessCb,
    onErrorCb,
    onSettledCb
}) => {
    const Client = apiClient(crudConfig);

    return useMutation({
        mutationKey: getMutationKey(),
        mutationFn: ({ update }) => Client.update(sessionToken, update.codeId, update),
        onSuccess: (data, variables, context) => {
            updateCacheArray({
                queryKey: getQueryKeyConceptDeterminationMethods(),
                action: CACHE_ACTIONS.UPDATE,
                primaryKey: uiConfig.primaryKey,
                data
            });
            queryClient.invalidateQueries({
                queryKey: getQueryKeyConceptDeterminationMethodById(data.codeId)
            });
            onSuccessCb?.({ context: variables?.context });
        },
        onError: (error) => {
            console.log('Error', error);
            onErrorCb?.(error);
        },
        onSettled: () => {
            onSettledCb?.();
        },
        refetchOnWindowFocus: false
    });
};
